import React from 'react'

import './styles/Category.scss'

import CategoryForm from './components/CategoryForm'
import CategoryList from './components/CategoryList'

const Category: React.FC = () => {
  return (
    <div className="row category">
      <CategoryForm />
      <CategoryList />
    </div>
  )
}

export default Category
